<mat-card-subtitle class="pt-0">
  <ng-container *ngIf="invoice.dueDate">
    {{ 'invoice-card.due-on' | translate }}
    {{ invoice.dueDate | momentDateTime: 'local' }}
    <a
      *ngIf="!invoice.paid"
      (click)="openDueDateDialog()"
      class="change-due-date-link text-warn"
    >{{ 'invoice-card.change-due-date' | translate }}</a>.

    <ng-container *ngIf="invoice.pastDue">
      <span class="text-warn">
        {{ 'invoice-card.past-due' | translate }} {{ invoice.pastDueDays }}
        {{ invoice.pastDueDays === 1 ? 'day' : 'days' }}.
      </span>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="invoice?.clinician">
    {{ 'invoice-card.created-by' | translate }}
    {{ invoice.clinician?.name }} on
    {{ invoice.createdAt | momentDateTime: 'local' }}.
  </ng-container>
</mat-card-subtitle>
